export const LANGUAGES: Language[] = [
    {
        code: 'en-US',
        name: 'English UK',
        flagPath: 'assets/images/flags/uk.svg'
    }
    // {
    //     code: 'sv-SE',
    //     name: 'Svenska',
    //     flagPath: 'assets/images/flags/sweden.svg'
    // }
];

export type Language = {
    code: string;
    name: string;
    flagPath: string;
};
